
    const data = {"name":"src/core/icons/arrow-expand-vertical","data":{"viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"M13 9v6h3l-4 4-4-4h3V9H8l4-4 4 4h-3M4 2h16v2H4V2m0 18h16v2H4v-2Z\"/>","originalColors":[],"stopColors":[]}}

            export default data
            